import { MergeWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Merge')
export class MergeNodeConnectorProvider extends ConnectorProvider<MergeWorkflowNode> {}
